'use client';

import { Suspense } from 'react';
import LoginScreen from '@/components/LoginScreen';

function LoginFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="animate-pulse rounded-lg bg-gray-200 h-64 w-96" aria-hidden />
    </div>
  );
}

export default function Home() {
  return (
    <Suspense fallback={<LoginFallback />}>
      <LoginScreen />
    </Suspense>
  );
}
